import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Grid, Col, Row, Form, FormGroup,
  ControlLabel, Button
} from 'react-bootstrap'
import Radio from '../../components/CustomRadio/CustomRadio'
import { constants } from '../../redux/lessons/actions'
import { canAnswerLesson } from '../../redux/lessons/reducer'
import { commonConstants } from '../../redux/common/actions'
import ClipLoader from 'react-spinners/ClipLoader'
import YoutubeEmbed from 'components/YoutubeEmbed'
import { useResponsive } from 'react-hooks-responsive'
import Card from "components/Card/Card.jsx";
import { getFormattedUser } from "../../services/auth";
import { default as Plotly } from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";
import { apiV2 } from 'services/api'
import LessonStats from './LessonStats'
import moment from 'moment'

const { FETCH_LESSON, FETCH_LESSON_RESPONSE } = constants
const { REQUEST } = commonConstants

const LessonSummary = ({ match, history }) => {
  const { loading, error, success, ...form } = useSelector(state => state.lessons)
  const canAnswer = useSelector(state => canAnswerLesson(state.lessons, match.params.id))
  const {
    id, title, videoUrl, documentUrl, questions, lessonResponse, updatedAt, description
  } = form

  const dispatch = useDispatch()
  // const searchParams = new URLSearchParams(window.location.search)
  // const readOnlyMode = searchParams.has('readOnly') && searchParams.get('readOnly') === 'true'

  const getLessonResponses = () => {
    if(match.params.id) {
      apiV2.lessonResponses.getAll(match.params.id)
        .then((res) => {
          setAllResponses(res)
        })
    }
  }

  // retrieve user
  const [callTakerId, setCallTakerId] = useState(null)
  const [hasAdmin, setHasAdmin] = useState(false)
  const [, setAllResponses] = useState([])
  useEffect(() => {
    async function getAuth() {
      const user = await getFormattedUser()
      const hasAdmin = user && user.roles && (user.roles.includes('SuperAdmin') || user.roles.includes('HrAdmin'))
      setHasAdmin(hasAdmin)
      setCallTakerId(user.id)
      console.log(hasAdmin)
      if(hasAdmin) {
        createPlotlyComponent(Plotly)
        getLessonResponses()
      }
    }
    getAuth().then()
  }, [])

  // handle submit
  const [historyNavigation, setHistoryNavigation] = useState({ enabled: false, id: null })
  useEffect(() => {
    if (historyNavigation.enabled) {
      history.push(`/admin/module/${historyNavigation.id}`)
    }
    return () => { }
  }, [historyNavigation.enabled])

  const resetLesson = () => {
    // Never reset a row that wasn't loaded for this module.
    if (!canAnswer || !lessonResponse.id) {
      return
    }
    apiV2.lessonResponses.complete(lessonResponse.id, false)
      .then(() => {
        return apiV2.lessonResponses.save({
          id: lessonResponse.id,
          lesson: match.params.id,
          responses: [],
          callTakerId: callTakerId,
        })
      })
      .then(() => {
        setHistoryNavigation({ enabled: true, id: id })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  // initial page fetch
  useEffect(() => {
    if (match.params.id) {
      dispatch({ type: FETCH_LESSON + REQUEST, payload: { id: match.params.id } })
      dispatch({ type: FETCH_LESSON_RESPONSE + REQUEST, payload: { lesson: match.params.id, call_taker_id: callTakerId } })
    }
    return () => { }
  }, [callTakerId, match.params.id, dispatch])

  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    return () => { }
  }, [success.message, error.message])

  // const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  // const submitRoute = match.params.id > 0 ? UPDATE_LESSON : SUBMIT_LESSON_FORM

  const breakpoints = { xs: 0, sm: 425, md: 1024 }
  const { size } = useResponsive(breakpoints)
  const radioStyle = size === 'xs' ? { transform: 'scale(3)', margin: 16, marginLeft: 30 } : {}


  if (loading.source === FETCH_LESSON) {
    return (
      <div className='main-content' style={{ textAlign: 'center' }}>
        <ClipLoader loading size={50} color="grey" />
      </div>
    )
  }

  const renderQuestions = () => {
    return questions.map((prop, index) => {
      return (
        <Card
          key={'question-card' + index}
          content={
            <>
              <Row>
                <Grid fluid>
                  <Row>
                    <Col xs={12} sm={12}>
                      <FormGroup>
                        <ControlLabel>
                          Question #{index + 1}
                        </ControlLabel>
                        <div><b>{prop.question}</b></div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Grid>
                {renderAnswers(index, prop.answers)}
              </Row>
            </>
          }
        />
      )
    })
  }

  const renderAnswers = (question_index, answers) => {
    return answers.map((prop, index) => {
      // let description = (!prop.correct && lessonResponse.responses[question_index] == index) ?
      //   (<div className='invalid' style={{color: 'red'}}>X<div>{prop.description}</div></div>)
      //     : (<div>{prop.description}</div>)
      return (
        <Row
          style={{ marginLeft: 20 }}
          key={'answer-row' + index}
        >
          <Col xs={12} sm={12}>
          <Form>

            <Radio
              id={'answer-' + index}
              type={'radio'}
              name="answer"
              disabled={true}
              checked={lessonResponse.responses[question_index] === index}
              label={prop.answer}
              style={radioStyle}
            />
            </Form>

            {prop.correct && lessonResponse.responses[question_index] === index &&
              <div>
                <div className="correct-answer">Correct: {prop.description}</div>
              </div>
            }
            {!prop.correct && lessonResponse.responses[question_index] === index &&
              <div>
                <div className="invalid-answer">Incorrect: {prop.description}</div>
              </div>
            }

          </Col>
        </Row>
      )
    })
  }

  const parseUrl = (url) => {
    if(url.includes('youtube')) {
      return url.substring(url.indexOf('v=') + 2)
    } else {
      return url
    }
  }

  const moduleNumber = id

  return (
    <div className='main-content'>
      <Grid fluid>
        <h3 style={{marginBottom: 20}}><b>Module #{moduleNumber} Summary:</b> {title}</h3>
        <h6><b>Date: </b>{moment(updatedAt).format('MMMM DD, YYYY')}</h6>
        <div style={{marginTop: 10}}>{description}</div>
        <Form>
          <Row>
            {/* <Col xs={12} sm={6}>
              <FormGroup>
                <ControlLabel>Module #{moduleNumber}</ControlLabel>
                <FormControl
                  type='text'
                  id='title'
                  name='title'
                  value={title ? title : ''}
                  disabled={readOnlyMode}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col>
            <Col xs={12} sm={6}>
              <FormGroup>
                <ControlLabel>Video Url</ControlLabel>
                <FormControl
                  type='text'
                  id='videoUrl'
                  name='videoUrl'
                  value={videoUrl ? videoUrl : ''}
                  disabled={readOnlyMode}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col> */}
            <Col xs={12} sm={6} style={{ marginBottom: 20 }}>
              {videoUrl &&
                <>
                  <h5>Module Video</h5>
                  <YoutubeEmbed embedId={parseUrl(videoUrl)} />
                </>
              }
              {documentUrl &&
                <h3>
                  <a href={documentUrl} target="_blank" rel="noopener noreferrer">View Module Questionnarie</a>
                </h3>
              }
            </Col>
          </Row>
        </Form>

        {renderQuestions()}

        <Row>
          <LessonStats hasAdmin={hasAdmin} id={match.params.id}/>
        </Row>

        <Row style={{marginTop: 20}}>
          <Col xs={12} sm={12}>
            <Button
              style={{ marginRight: '15px' }}
              bsStyle='warning'
              bsSize="lg"
              onClick={() => { window.location.href = "/admin/professional-development" }}
            >
              Back
            </Button>
            <Button
              style={{ marginRight: '15px' }}
              bsStyle='primary'
              bsSize="lg"
              onClick={() => resetLesson()}
            >
              Retake Module
            </Button>
          </Col>
        </Row>
      </Grid>
    </div>
  )
}

// function handleChange(dispatch, event, formField) {
//   let field = null
//   let value = null
//   if (formField === 'dateVerified') {
//     field = formField
//     value = event._d
//   } else if (event.target) {
//     field = event.target.name
//     value = event.target.value
//     value = value === "true" ? true : value
//     value = value === "false" ? false : value
//   } else { // select form items
//     field = formField
//     value = event
//   }
//   return dispatch({ type: UPDATE_LESSON_FORM_FIELD, field, value })
// }

export default LessonSummary